import * as React from "react"
import * as styles from "./styles.module.scss"
import Button from "../Button"

const TrillionProblem: React.FC = () => {
  return (
    <section className={styles.textBlock}>
      <div className={styles.pagePadding}>
        <div className={styles.message}>
          <div className={styles.header}>
            <h2 className={styles.heading}>The $13 Trillion Problem</h2>
          </div>
          <div className={styles.body}>
            <p className={styles.paragraph}>
              Mortgages are a $13 trillion industry.
            </p>
            <p className={styles.paragraph}>
              For such a massive and critical industry, home finance has avoided
              technological advancement for decades. Traditional systems are
              confusing and slow, and they aren’t aligned with your best
              interests.
            </p>
            <p className={styles.paragraph}>
              Our platform puts you in the driver seat, providing you with full
              transparency into the process and saving you time that would have
              been wasted through inefficient and sloppy practices.
            </p>
            <p className={styles.paragraph}>We’re making it better.</p>
          </div>
          <div className={styles.actions}>
            <a
              href="/content/what-is-better-mortgage/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button type="primary" size="lg" halo={true}>
                Learn more
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TrillionProblem
